import { ScreenLogType as c } from "../../constants/screenLog.js";
import { useScreenLogContext as a } from "../../contexts/share/ScreenLogContext.js";
import { useCallback as l } from "react";
const g = () => {
  const {
    enabled: t,
    insert: n
  } = a();
  return {
    intercept: l((o) => async (...e) => {
      const {
        operation: p = "unknown",
        type: s = c.Unknown,
        input: i,
        runJob: r
      } = o;
      if (t) {
        const u = await r(...e);
        return n({
          operation: p,
          type: s,
          input: i ?? e,
          output: u
        }), u;
      } else
        return r(...e);
    }, [t, n]),
    screenLog: (o, e) => {
      t && n({
        operation: o,
        type: c.Manual,
        input: e,
        output: ""
      });
    }
  };
};
export {
  g as default
};
//# sourceMappingURL=useScreenLog.js.map
